export const hasAnyProperty = obj => Object.keys(obj).some(p => obj.hasOwnProperty(p));
